import React from 'react';
import { Pagination as ReactPagination } from 'react-bootstrap';

interface Props {
  page: number;
  size: number;
  total: number;
  fetchPage: (page: number) => void;
}

export const Pagination = ({ size, page, total, fetchPage }: Props) => {
  const rows = [];

  const totalPages = Math.ceil(total / size);
  if (totalPages <= 1) {
    return null;
  }
  if (page !== 0) {
    rows.push(<ReactPagination.First key='first' onClick={() => fetchPage(0)} />);
  }
  if (page > 0) {
    rows.push(<ReactPagination.Prev key='previous' onClick={() => fetchPage(page - 1)} />);
  }
  if (totalPages <= 5) {
    for (let i = 0; i < totalPages; i++) {
      rows.push(
        <ReactPagination.Item key={i} onClick={() => fetchPage(i)} active={page === i}>
          {i + 1}
        </ReactPagination.Item>
      );
    }
  } else {
    rows.push(
      <ReactPagination.Item active={page === 0} key='0' onClick={() => fetchPage(0)}>
        {1}
      </ReactPagination.Item>
    );
    const min = page > 2 ? page - 2 : 1;
    const max = page < totalPages - 3 ? page + 2 : totalPages - 2;
    if (min > 1) {
      rows.push(<ReactPagination.Ellipsis key='first-ellips' />);
    }
    for (let i = min; i <= max; i++) {
      rows.push(
        <ReactPagination.Item key={i} onClick={() => fetchPage(i)} active={page === i}>
          {i + 1}
        </ReactPagination.Item>
      );
    }
    if (page < totalPages - 4) {
      rows.push(<ReactPagination.Ellipsis key='second-ellips' />);
    }
    rows.push(
      <ReactPagination.Item
        active={page === totalPages - 1}
        key={totalPages - 1}
        onClick={() => fetchPage(totalPages - 1)}
      >
        {totalPages}
      </ReactPagination.Item>
    );
  }
  if (page < totalPages - 1) {
    rows.push(<ReactPagination.Next key='next' onClick={() => fetchPage(page + 1)} />);
  }
  if (page !== totalPages - 1) {
    rows.push(<ReactPagination.Last key='last' onClick={() => fetchPage(totalPages - 1)} />);
  }

  return (
    <div className='d-flex justify-content-end'>
      <ReactPagination role='navigation'>{rows}</ReactPagination>
    </div>
  );
};

export default Pagination;
